import { ImageSize } from './types'

export function ImageSizeToArrayPx(imageSize: ImageSize): number[][] {
    return [
        [imageSize.header.px.x, imageSize.header.px.y, imageSize.header.px.width, imageSize.header.px.height],
        [imageSize.body.px.x, imageSize.body.px.y, imageSize.body.px.width, imageSize.body.px.height],
        [imageSize.footer.px.x, imageSize.footer.px.y, imageSize.footer.px.width, imageSize.footer.px.height]
    ]
}
